import { Modal } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

export const ImportBudgetModalLoader = () => {
  const { t } = useTranslation('global');

  return (
    <Modal
      isOpen
      iconName="arrow-path"
      iconVariant="info"
      title={t('budget.budgetaryExercise.importModal.loader.title')}
      subtitle={t('budget.budgetaryExercise.importModal.loader.subtitle')}
      actions={[]}
    />
  );
};
